var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9998 0C62.0911 0 80 17.9085 80 40.0002C80 62.0919 62.0911 80.0004 39.9998 80.0004C17.9085 80.0004 0 62.0919 0 40.0002C0 17.9085 17.9085 0 39.9998 0Z",
    fill: "#22A08C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2028 23.2115C36.1896 23.2428 36.1855 23.2758 36.1855 23.3083H36.1826V60.1191V60.7705V62.4314H36.1954V63.2921C36.1954 64.585 37.2436 65.6336 38.5361 65.6336H41.4622C42.7548 65.6336 43.8033 64.585 43.8033 63.2921V62.4314H43.8157V60.7705V60.1191V23.3083H43.8137C43.8137 23.2758 43.8091 23.2428 43.7963 23.2115L43.6995 22.9746H36.3L36.2028 23.2115Z",
    fill: "#2E313D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5899 17.821L40.2364 14.51C40.1969 14.4132 40.1029 14.3506 39.9983 14.3506C39.894 14.3506 39.8005 14.4132 39.7605 14.51L38.4066 17.821H38.4071L36.2983 22.9742H43.6978L41.5899 17.821Z",
    fill: "#ECEDBE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2764 63.2925C56.2764 64.5854 55.2282 65.634 53.9353 65.634H51.0096C49.7166 65.634 48.6685 64.5854 48.6685 63.2925V57.3425C48.6685 56.0496 49.7162 55.001 51.0096 55.001H53.9353C55.2282 55.001 56.2764 56.0492 56.2764 57.3425V63.2925Z",
    fill: "#EE563D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2884 23.3091H48.6558V60.7708H56.2884V23.3091Z",
    fill: "#B4BE1F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9318 23.3091H51.0122V60.7708H53.9318V23.3091Z",
    fill: "#2E313D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2884 60.1196H48.6558V62.4319H56.2884V60.1196Z",
    fill: "#ECEDBE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2679 23.2113L54.064 17.8208H50.8803L48.6752 23.2113C48.6422 23.2904 48.6517 23.3802 48.6995 23.4515C48.7473 23.5228 48.8272 23.5652 48.9129 23.5652H56.031C56.1171 23.5652 56.1971 23.5228 56.244 23.4515C56.291 23.3802 56.3005 23.2904 56.2679 23.2113Z",
    fill: "#ECEDBE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7097 14.5096C52.6702 14.4132 52.5758 14.3506 52.4716 14.3506C52.3674 14.3506 52.2738 14.4132 52.2339 14.5096L50.8804 17.8206H54.0632L52.7097 14.5096Z",
    fill: "#2E313D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8158 60.7705H43.8149V62.4314H43.8158V60.7705Z",
    fill: "#ECEDBE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8158 60.1196H43.8149V60.771H43.8158V60.1196Z",
    fill: "#ECEDBE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7124 63.3009C23.7124 64.5979 24.7639 65.6485 26.0605 65.6485H28.9957C30.2924 65.6485 31.3434 64.5979 31.3434 63.3009V62.4307H23.7128L23.7124 63.3009Z",
    fill: "#E14C34"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3001 23.4516C31.2531 23.5229 31.1719 23.5654 31.087 23.5654H28.9878V54.9852H28.9956C30.2922 54.9852 31.3429 56.0363 31.3429 57.3325V60.1194H31.3437V23.3091H31.3388C31.3388 23.3593 31.3289 23.4092 31.3001 23.4516Z",
    fill: "#2E313D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3383 23.3086C31.3383 23.3589 31.3284 23.4087 31.2996 23.4516C31.2526 23.5228 31.1714 23.5649 31.0866 23.5649H28.9873V54.9847V60.1189H31.3424H31.3432V23.3086H31.3383Z",
    fill: "#262834"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7546 23.451C23.7262 23.4082 23.7163 23.3583 23.7167 23.3076H23.7109V60.1184H23.7118H26.0669V54.9838V23.5643H23.9676C23.8823 23.5647 23.8024 23.5227 23.7546 23.451Z",
    fill: "#262834"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0679 23.5654V54.9853V60.1195H28.9883V54.9853V23.5654H26.0679Z",
    fill: "#A9B214"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3252 23.2113L29.1197 17.8208H25.9364L23.7313 23.2113C23.7189 23.2426 23.7173 23.2755 23.7173 23.3085C23.7173 23.3588 23.7268 23.4086 23.7552 23.4515C23.803 23.5228 23.8829 23.5648 23.9686 23.5648H26.0679H28.9883H31.0879C31.1732 23.5648 31.2536 23.5223 31.3009 23.4515C31.3302 23.4086 31.3397 23.3588 31.3397 23.3085C31.3388 23.2755 31.338 23.2422 31.3252 23.2113Z",
    fill: "#E0E1B3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7658 14.5096C27.7259 14.4132 27.6319 14.3506 27.5281 14.3506C27.4234 14.3506 27.3299 14.4132 27.2899 14.5096L25.936 17.8206H29.1189L27.7658 14.5096Z",
    fill: "#A9B214"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7118 60.7705H23.7109V62.4314H23.7118V60.7705Z",
    fill: "#ECEDBE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M23.7118 60.7705H23.7109V62.4314H23.7118V60.7705Z",
    fill: "#EE563D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3436 60.7705H31.3428V62.4314H31.3436V60.7705Z",
    fill: "#ECEDBE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M31.3436 60.7705H31.3428V62.4314H31.3436V60.7705Z",
    fill: "#EE563D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7118 60.1196H23.7109V60.771H23.7118V60.1196Z",
    fill: "#ECEDBE"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M23.7118 60.1196H23.7109V60.771H23.7118V60.1196Z",
    fill: "#EE563D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3436 60.1196H31.3428V60.771H31.3436V60.1196Z",
    fill: "#ECEDBE"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M31.3436 60.1196H31.3428V60.771H31.3436V60.1196Z",
    fill: "#EE563D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9879 60.1196H26.0675H23.7124V60.771V62.4315H31.3434V60.771V60.1196H28.9879Z",
    fill: "#ECEDBE"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8096 23.3086C43.8096 23.3589 43.8002 23.4087 43.7717 23.4516C43.7252 23.5228 43.6436 23.5649 43.5587 23.5649H41.4595V54.986V60.1185H43.8142H43.815V23.3086H43.8096Z",
    fill: "#EE563D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2255 23.451C36.197 23.4082 36.1876 23.3583 36.1876 23.3076H36.1826V60.1184H36.1834H38.5381V54.9854V23.5643H36.4389C36.3528 23.5647 36.2737 23.5227 36.2255 23.451Z",
    fill: "#EE563D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2254 23.3754C36.2023 23.3325 36.1937 23.2827 36.1937 23.2324H36.1899V60.0424L36.5929 60.9719L38.5409 60.5693L39.271 55.0005L39.2047 23.5649L36.4017 23.4883C36.3309 23.4891 36.2653 23.4467 36.2254 23.3754Z",
    fill: "#E14C3E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1839 60.7705H36.1831V62.4314H36.1839V60.7705Z",
    fill: "#ECEDBE"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M36.1839 60.7705H36.1831V62.4314H36.1839V60.7705Z",
    fill: "#EE563D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1839 60.1196H36.1831V60.771H36.1839V60.1196Z",
    fill: "#ECEDBE"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M36.1839 60.1196H36.1831V60.771H36.1839V60.1196Z",
    fill: "#EE563D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M40 62.4307V65.6473H40.2097H41.4672C42.7638 65.6473 43.8145 64.5967 43.8145 63.2996V62.4307H40.2097H40Z",
    fill: "#B4BE1F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M40 23.5654V60.1195H40.2097H41.4602V54.9865V23.5654H40.2097H40Z",
    fill: "#2E313D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4602 60.1196H40.2097H40V62.4315H40.2097H43.8149V60.771V60.1196H41.4602Z",
    fill: "#ECEDBE"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M40 17.8212V23.5652H40.2097H41.4598H43.559C43.6443 23.5652 43.7251 23.5228 43.772 23.4515C43.8005 23.4086 43.81 23.3588 43.81 23.3081C43.81 23.2755 43.8083 23.2422 43.7968 23.2113L41.5912 17.8208H40.2093L40 17.8212Z",
    fill: "#ECEDBE"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2091 17.8206H41.591H41.5914L40.2371 14.5096C40.2297 14.4923 40.2186 14.4775 40.2083 14.4627C40.1609 14.3943 40.0842 14.3506 39.9985 14.3506V17.8206H40.2091Z",
    fill: "#EE563D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1851 62.4307V63.2996C36.1851 64.5962 37.2369 65.6473 38.5332 65.6473H40V62.4307H36.1851Z",
    fill: "#A9B214"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M38.54 23.5654V54.9865V60.1195H40.0002V23.5654H38.54Z",
    fill: "#262834"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1851 60.1196V60.771V62.4315H40V60.1196H38.5398H36.1851Z",
    fill: "#ECEDBE"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0003 17.8208H38.4087L36.2039 23.2113C36.1912 23.2426 36.1899 23.2755 36.1899 23.3081C36.1899 23.3584 36.1994 23.4086 36.2278 23.4515C36.2761 23.5228 36.3552 23.5652 36.4413 23.5652H38.5405H40.0007L40.0003 17.8208Z",
    fill: "#E0E1B3"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7629 14.5096L38.4082 17.8206H39.9998V14.3506C39.8956 14.3506 39.8021 14.4132 39.7629 14.5096Z",
    fill: "#E14C3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarks);
export default __webpack_public_path__ + "static/media/marks.785a75efa5c5c73fd715e4b9709445da.svg";
export { ForwardRef as ReactComponent };